var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-add-remove-btn"},[_c('q-btn',{attrs:{"label":"+","no-caps":"","color":"orange-9"},on:{"click":_vm.onAdd}}),_c('q-btn',{attrs:{"label":"-","outline":"","no-caps":""},on:{"click":_vm.onRemove}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }